import React, { Component } from "react";
import {
    CustomTextField as TextField,
    CustomChip as Chip,
    CustomDialog as Dialog,
    CustomPrimaryButton as SaveButton,
    CustomSecondaryButton as CancelButton
} from "./components";
import Cx from "classnames";

const styles = {
    chip: {
        margin: 4
    }
};

export default class CustomDialogSelect extends Component {
    constructor() {
        super();
        this.state = {
            openDialog: false
        };
    }

    render() {
        const {
            required = "",
            onSelect,
            children,
            value,
            data,
            onRequestDelete,
            onSaveDialog,
            onCancelDialog,
            ...rest
        } = this.props;
        const { openDialog } = this.state;
        // let chips = value.map((id, i) => {
        //     let obj = this.findObj(data, id);
        //     if (obj) {
        //         return (
        //             <Chip
        //                 key={i}
        //                 onRequestDelete={() => onRequestDelete(id)}
        //                 label={obj.name}
        //                 style={styles.chip}
        //             />
        //         );
        //     }
        // });

        return (
            <div className="DialogSelect">
                {/* {value.length === 0 && ( */}
                <TextField
                    {...rest}
                    required={required}
                    onClick={() => this.setState({ openDialog: true })}
                    isWidgetComp
                    value={value.length > 0 ? `${value.length} of ${data.length} selected` : ""}
                    clearMargin
                    removeMargin
                />
                {/* )} */}
                {/* <TextField
                    className={Cx({ select: true, selected: value.length > 0 })}
                    onClick={() => this.setState({ openDialog: true })}
                >
                    SELECT
                </div>*/}
                {/* {value.length !== 0 && (
                    <div>
                        <div
                            style={{
                                color: "#54698d",
                                fontSize: "12px",
                                fontWeight: 500,
                                fontFamily: "Roboto-Regular"
                            }}
                        >
                            {rest.floatingLabelText}
                            {required && <span className="required-input">*</span>}
                        </div>
                        <div className="chips">{chips}</div>
                    </div>
                )} */}
                <Dialog
                    modal={false}
                    actions={[
                        <CancelButton
                            label="Cancel"
                            onClick={() => {
                                this.setState({ openDialog: false });
                                onCancelDialog();
                            }}
                            key="1"
                            isWidgetComp
                        />,
                        <SaveButton
                            label="Save"
                            onClick={() => {
                                this.setState({ openDialog: false });
                                onSaveDialog();
                            }}
                            key="2"
                            className="margin-l-16"
                            isWidgetComp
                        />
                    ]}
                    open={openDialog}
                    title={rest.floatingLabelText}
                    onRequestClose={() => {
                        this.setState({ openDialog: false });
                        onCancelDialog();
                    }}
                    contentStyle={{ maxWidth: "500px" }}
                >
                    <div>{children}</div>
                </Dialog>
            </div>
        );
    }

    findObj = (data, id) => {
        for (const elm of data) {
            if (elm.id === id) {
                return elm;
            } else if (elm.child && Array.isArray(elm.child) && elm.child.length > 0) {
                let val = this.findObj(elm.child, id);
                if (val) return val;
            }
        }
    };
}
